import { SxProps, Theme, Grid, styled } from "@mui/material";

export const GridHeaderTable = styled(Grid)(() => ({
  backgroundColor: "#EDF5FB",
  padding: "0 16px",
  borderRadius: "8px"
}));

const styles: { [x: string]: SxProps<Theme> } = {
  badgeTaskType: {
    width: "fit-content",
    height: "auto",
    marginLeft: "-10px",
    padding: "2px 0"
  },
  badgeText: {
    lineHeight: "auto"
  }
};

export default styles;
